module.exports = __webpack_public_path__ + "static/media/grin-alt.193a7884.svg";